export const API = process.env.REACT_APP_API_URL
export const BEARER = "Bearer "
export const SERVICE = "restaurant"
export const KIND = "meal"
